<template>
    <div class="project bg_white" v-show="show">
        <div class="header">
            <div class="filter">
<!--                <div class="fl f14 bold400 txt_black85">-->
<!--                    <span>项目名称：</span>-->
<!--                    <input type="text" @blur="nameChange" />-->
<!--                </div>-->
                <div class="fl f14 bold400 txt_black85" v-if="role==='admin'">
                    <span>代理商名称：</span>
                    <input type="text" @blur="agentChange" />
                </div>
            </div>
            <button v-if="this.role==='agent'" type="create" class="fr" @click="createEvent">新建</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData"
               @deleteEvent="deleteEvent" @editEvent="editEvent" @pointEvent="pointEvent"></lists>
        <project-detail ref="projectDetail" @updateData="$refs.lists.updateData()"></project-detail>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import ProjectDetail from './projectDetail'
    import {mapGetters} from "vuex";

    export default {
        name: "project",
        components: {
            Lists, ProjectDetail
        },
        data() {
            return {
                show: true,
                filter: {},
                lists: {
                    title: [{text: '项目名称'}, {text: '项目编号'}, {text: '项目地址'}, {text: '代理商'}, {text: '联系人'}, {text: '联系人电话'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '14%', textAlign: 'left'},
                    {width: '13%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '13%', textAlign: 'left'},
                    {width: '12%', textAlign: 'left'},
                    {width: '14%', textAlign: 'left', marginLeft: '5%'},
                ],
                httpRequestData: {
                    url: '/manage/project',
                    func: this.httpRequestHandle,
                    error: '获取项目信息出错',
                    auto: false
                },
            }
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        methods: {
            init() {
                this.show = true;
                this.$refs.lists.updateData();
            },
            httpRequestHandle(data) {
                let operation = this.role === 'admin' || this.role === 'partner' ? {
                    arr: [{
                        text: '点位',
                        style: {color: '#1890FF'},
                        event: 'pointEvent'
                    },]
                } : {
                    arr: [
                        // {text: '删除', style: {color: '#FF2118'}, event: 'deleteEvent'},
                        {text: '编辑', style: {color: '#1890FF'}, event: 'editEvent'},
                        {text: '点位', style: {color: '#1890FF'}, event: 'pointEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.name},
                        {text: item.no},
                        {text: item.address},
                        {text: item.agent},
                        {text: item.contacts},
                        {text: item.phone},
                        // {text: this.$config.pointStatus.get(item.status)},
                        operation
                    ]
                });
            },
            nameChange(event) {
                this.filter.name = event.target.value || '';
                this.$refs.lists.updateData(this.filter);
            },
            agentChange(event) {
                this.filter.agent = event.target.value || '';
                this.$refs.lists.updateData(this.filter);
            },
            createEvent() {
                this.$refs.projectDetail.init('create',{});
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除项目',
                    tooltipContent: '请输入当前项目名称以删除当前项目,数据将不可恢复，谨慎操作',
                    value: data.name,
                    confirm: () => {
                        this.$api.delete('/manage/project/' + data.id).then(() => {
                            this.$alert.success({content: '删除成功'});
                            this.$refs.lists.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '删除失败'});
                        });
                    }
                })
            },
            editEvent(data) {
                this.$refs.projectDetail.init('edit',data);
            },
            pointEvent(data) {
                this.show = false;
                this.$emit('navigation', 'point', data.id);
            }
        }
    }
</script>

<style scoped>
    .project {
        padding: 0 5px;
    }

    .project > .header {
        height: 80px;
        padding: 0 15px;
    }

    .project > .header > button {
        margin-top: 20px;
    }

    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }
    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
    }
</style>